import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popover-title" }
const _hoisted_2 = { style: {"padding":"4px 16px 8px 0"} }
const _hoisted_3 = {
  class: "column-fixed",
  style: {"float":"right"}
}
const _hoisted_4 = { style: {"padding":"4px 16px 8px 0"} }
const _hoisted_5 = {
  class: "column-fixed",
  style: {"float":"right"}
}
const _hoisted_6 = { style: {"padding":"4px 16px 8px 0"} }
const _hoisted_7 = {
  class: "column-fixed",
  style: {"float":"right"}
}

import { computed, nextTick, ref, unref, watch } from "vue";
import {
  SettingOutlined,
  VerticalRightOutlined,
  VerticalLeftOutlined,
  DragOutlined,
} from "@ant-design/icons-vue";
import { cloneDeep } from "lodash-es";
import { Tooltip, Popover, Divider } from "ant-design-vue";
import { useTableContext } from "../../hooks/useTableContext";
import type { TableColumn } from "../../types/column";
import Checkbox from "@/components/basic/check-box/index.vue";
import { useSortable } from "../../hooks/useSortable";
import { isNullAndUnDef } from "../../../../../utils/is";
import { formatAutoCols } from "../../hooks/editable-cols";

type TableColumnType<T = any> = TableColumn<T> & {
  /** 目的是解决：类型实例化过深，且可能无限 */
  formItemProps?: any;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'column-setting',
  emits: ["clos-change-by-tools", "edit-row-data-change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const table = useTableContext();
let inited = false;

const defaultColumns = cloneDeep<TableColumnType[]>(
  table.columns.length > 0 ? table.columns : formatAutoCols(table, emit)
);

const defaultShowIndex = !!table.showIndex;
const defaultBordered = table.bordered;
const tableColumns = ref<TableColumnType[]>([]);

const checkAll = computed<boolean>({
  get() {
    return (
      tableColumns.value.length > 0 &&
      tableColumns.value.every((n) => !n.hideInTable)
    );
  },
  set(value) {
    tableColumns.value.forEach((item) => (item.hideInTable = !value));
  },
});

const checkIndex = ref(defaultShowIndex);
const checkBordered = ref(table.bordered);
const columnListRefLeft = ref<HTMLDivElement>();
const columnListRefCom = ref<HTMLDivElement>();
const columnListRefRight = ref<HTMLDivElement>();

// 初始化选中状态
const initCheckStatus = () => {
  //@ts-ignore
  tableColumns.value = cloneDeep(defaultColumns);
  checkIndex.value = defaultShowIndex;
  checkBordered.value = defaultBordered;
  tableColumns.value.forEach((item) => (item.hideInTable ??= false));
  table.setProps({
    //@ts-ignore
    columns: tableColumns.value,
  });
};

const handleColsChange = () => {
  //列改变状态
  nextTick(() => {
    const CurrentShowCols = tableColumns.value.filter((item) => {
      return item.hideInTable == false;
    });
    emit("clos-change-by-tools", CurrentShowCols);
  });
};
initCheckStatus();

const indeterminate = computed(() => {
  return (
    tableColumns.value.length > 0 &&
    tableColumns.value.some((n) => n.hideInTable) &&
    tableColumns.value.some((n) => !n.hideInTable)
  );
});

const leftCols = computed(() => {
  return tableColumns.value.filter((item) => {
    return item.fixed == true || item.fixed == "left";
  });
});

const rightCols = computed(() => {
  return tableColumns.value.filter((item) => {
    return item.fixed == "right";
  });
});

const comCols = computed(() => {
  return tableColumns.value.filter((item) => {
    return typeof item.fixed == "undefined" || item.fixed == false;
  });
});

watch(
  tableColumns,
  (columns) => {
    //@ts-ignore
    table.setProps({ columns });
  },
  {
    deep: true,
  }
);
// 设置序号列
const handleIndexCheckChange = (e) => {
  table.setProps({ showIndex: e.target.checked });
};
// 设置边框
const handleBorderedCheckChange = (e) => {
  table.setProps({ bordered: e.target.checked });
};

const handleColumnFixed = (
  columItem: TableColumn,
  direction: "left" | "right"
) => {
  columItem.fixed = columItem.fixed === direction ? false : direction;
  for (let i = 0; i < tableColumns.value.length; i++) {
    if (tableColumns.value[i].dataIndex == columItem.dataIndex) {
      if (columItem.fixed == "left") {
        tableColumns.value.splice(i, 1);
        tableColumns.value.unshift(columItem);
      } else {
        let targetCols = tableColumns.value.filter((item) => {
          return item.dataIndex?.toString().toLowerCase() == "action";
        });
        if (targetCols.length > 0) {
          tableColumns.value.splice(i, 1);
          //如果有操作列的情况下，要把操作列固定在最右侧
          let tempItem = tableColumns.value.pop();
          tableColumns.value.push(columItem);
          //@ts-ignore
          tableColumns.value.push(tempItem);
        } else {
          tableColumns.value.splice(i, 1);
          tableColumns.value.push(columItem);
        }
      }
    }
  }
  //@ts-ignore
  table.setProps({ columns: tableColumns.value });
  if (table.columnFilter.length > 0)
    emit("clos-change-by-tools", tableColumns.value); //工具栏中设置改变的时候需要通知外部进行变更
};

async function handleVisibleChange() {
  if (inited) return;
  await nextTick();
  const columnListEl = unref(columnListRefLeft);
  if (!columnListEl) return;
  const columnListCom = unref(columnListRefCom);
  const columnListRight = unref(columnListRefRight);
  // Drag and drop sort
  const { initSortable } = useSortable(
    columnListEl,
    columnListCom,
    columnListRight,
    {
      handle: ".table-column-drag-icon",
      onEnd: (evt) => {
        const { oldIndex, newIndex } = evt;
        if (
          isNullAndUnDef(oldIndex) ||
          isNullAndUnDef(newIndex) ||
          oldIndex === newIndex
        ) {
          return;
        }
        const columns = tableColumns.value;
        columns.splice(newIndex, 0, columns.splice(oldIndex, 1)[0]);
        if (table.columnFilter.length > 0)
          emit("clos-change-by-tools", tableColumns.value); //工具栏中设置改变的时候需要通知外部进行变更
      },
    }
  );
  initSortable();
  inited = true;
}

const reset = () => {
  initCheckStatus();
  table.setProps({ showIndex: defaultShowIndex, bordered: defaultBordered });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createBlock(_unref(Tooltip), { placement: "top" }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("component.table.settingColumn")), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Popover), {
        placement: "bottomLeft",
        trigger: "click",
        "overlay-class-name": "cloumn-list",
        onOpenChange: handleVisibleChange
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Checkbox, {
              checked: checkAll.value,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checkAll).value = $event)),
              indeterminate: indeterminate.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingColumnShow")), 1)
              ]),
              _: 1
            }, 8, ["checked", "indeterminate"]),
            _createVNode(Checkbox, {
              checked: checkIndex.value,
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((checkIndex).value = $event)),
              onChange: handleIndexCheckChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingIndexColumnShow")), 1)
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(Checkbox, {
              checked: checkBordered.value,
              "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((checkBordered).value = $event)),
              onChange: handleBorderedCheckChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingBordered")), 1)
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_a_button, {
              size: "small",
              type: "link",
              onClick: reset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.resetText")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "columnListRefLeft",
            ref: columnListRefLeft
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftCols.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: _unref(table).getColumnKey(item),
                class: "check-item"
              }, [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_unref(DragOutlined), { class: "table-column-drag-icon pr-6px cursor-move" }),
                  _createVNode(Checkbox, {
                    checked: item.hideInTable,
                    "onUpdate:checked": ($event: any) => ((item.hideInTable) = $event),
                    "true-value": false,
                    "false-value": true,
                    onChange: handleColsChange
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["checked", "onUpdate:checked"])
                ]),
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_unref(Tooltip), {
                    placement: "bottomLeft",
                    "mouse-leave-delay": 0.4
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingFixedLeft")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VerticalRightOutlined), {
                        class: _normalizeClass(["fixed-left", { active: item.fixed === 'left' }]),
                        onClick: ($event: any) => (handleColumnFixed(item, 'left'))
                      }, null, 8, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(Divider), { type: "vertical" }),
                  _createVNode(_unref(Tooltip), {
                    placement: "bottomLeft",
                    "mouse-leave-delay": 0.4
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingFixedRight")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VerticalLeftOutlined), {
                        class: _normalizeClass(["fixed-right", { active: item.fixed === 'right' }]),
                        onClick: ($event: any) => (handleColumnFixed(item, 'right'))
                      }, null, 8, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ], 512),
          _createElementVNode("div", {
            ref_key: "columnListRefCom",
            ref: columnListRefCom
          }, [
            (leftCols.value.length > 0)
              ? (_openBlock(), _createBlock(_component_a_divider, {
                  key: 0,
                  style: {"border-color":"#7cb305","margin":"2px 0","height":"2px"}
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comCols.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: _unref(table).getColumnKey(item),
                class: "check-item"
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_unref(DragOutlined), { class: "table-column-drag-icon pr-6px cursor-move" }),
                  _createVNode(Checkbox, {
                    checked: item.hideInTable,
                    "onUpdate:checked": ($event: any) => ((item.hideInTable) = $event),
                    "true-value": false,
                    "false-value": true,
                    onChange: handleColsChange
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["checked", "onUpdate:checked"])
                ]),
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_unref(Tooltip), {
                    placement: "bottomLeft",
                    "mouse-leave-delay": 0.4
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingFixedLeft")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VerticalRightOutlined), {
                        class: _normalizeClass(["fixed-left", { active: item.fixed === 'left' }]),
                        onClick: ($event: any) => (handleColumnFixed(item, 'left'))
                      }, null, 8, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(Divider), { type: "vertical" }),
                  _createVNode(_unref(Tooltip), {
                    placement: "bottomLeft",
                    "mouse-leave-delay": 0.4
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingFixedRight")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VerticalLeftOutlined), {
                        class: _normalizeClass(["fixed-right", { active: item.fixed === 'right' }]),
                        onClick: ($event: any) => (handleColumnFixed(item, 'right'))
                      }, null, 8, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ], 512),
          _createElementVNode("div", {
            ref_key: "columnListRefRight",
            ref: columnListRefRight
          }, [
            (rightCols.value.length > 0)
              ? (_openBlock(), _createBlock(_component_a_divider, {
                  key: 0,
                  style: {"border-color":"#7cb305","margin":"5px 0","height":"2px"}
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightCols.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: _unref(table).getColumnKey(item),
                class: "check-item"
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_unref(DragOutlined), { class: "table-column-drag-icon pr-6px cursor-move" }),
                  _createVNode(Checkbox, {
                    checked: item.hideInTable,
                    "onUpdate:checked": ($event: any) => ((item.hideInTable) = $event),
                    "true-value": false,
                    "false-value": true,
                    onChange: handleColsChange
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["checked", "onUpdate:checked"])
                ]),
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_unref(Tooltip), {
                    placement: "bottomLeft",
                    "mouse-leave-delay": 0.4
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingFixedLeft")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VerticalRightOutlined), {
                        class: _normalizeClass(["fixed-left", { active: item.fixed === 'left' }]),
                        onClick: ($event: any) => (handleColumnFixed(item, 'left'))
                      }, null, 8, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(Divider), { type: "vertical" }),
                  _createVNode(_unref(Tooltip), {
                    placement: "bottomLeft",
                    "mouse-leave-delay": 0.4
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("component.table.settingFixedRight")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(VerticalLeftOutlined), {
                        class: _normalizeClass(["fixed-right", { active: item.fixed === 'right' }]),
                        onClick: ($event: any) => (handleColumnFixed(item, 'right'))
                      }, null, 8, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            }), 128))
          ], 512)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(SettingOutlined))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})